import type { I18nService } from '@recruitee/i18n';

import type { UnitPrecision, UnitType } from './types';
import { formatDuration } from './value-formatter-duration';
import type { NumberFormatOptions } from './value-formatter-number';
import { formatNumber } from './value-formatter-number';
import { formatRate } from './value-formatter-rate';

export function valueFormatter(
  value: string | number,
  options: {
    unitType: UnitType;
    unitPrecision?: UnitPrecision | null;
  },
  i18n: I18nService,
  opts?: {
    number: NumberFormatOptions;
  },
) {
  switch (options.unitType) {
    case 'rate':
      return formatRate(value);

    case 'duration':
      switch (options.unitPrecision) {
        case 'minutes':
          return formatDuration(<number>value * 60, i18n);

        case 'seconds':
        default:
          return formatDuration(<number>value, i18n);
      }

    case 'number':
    default:
      return formatNumber(<number>value, opts?.number);
  }
}
